export class OrganizationNotFoundError extends Error {}
